import { PATHS } from '@/config/paths';

export const eqiPlusServices = [
  {
    title: 'EQI Research',
    thumb: '/assets/images/cross-sell/Research.png',
    icon: 'ImportantDevicesOutline',
    path: PATHS.hubs.research,
  },
  // {
  //   title: "Jornadas",
  //   thumb: "/assets/images/cross-sell/Jornada.png",
  //   path: "#",
  // },
  {
    title: 'Cursos',
    thumb: '/assets/images/cross-sell/Cursos.png',
    icon: 'SchoolOutline',
    path: PATHS.hubs.courses,
  },
  {
    title: 'Filmes, Séries e Podcasts',
    thumb: '/assets/images/cross-sell/Filmes_podcasts_series.png',
    icon: 'LiveTvOutline',
    path: PATHS.hubs.movies,
  },
  {
    title: 'Notícias',
    thumb: '/assets/images/cross-sell/Noticias.png',
    icon: 'CupOutline',
    path: PATHS.news.index,
  },
  // {
  //   title: "Eventos",
  //   thumb: "/assets/images/cross-sell/Eventos.png",
  //   path: "#",
  // },
];

export const eqiPlusContent = [
  {
    title: 'Cartões',
    thumb: '',
    icon: 'CardOutline',
    path: PATHS.lp.creditCard,
  },
  {
    title: 'Câmbio',
    thumb: '',
    icon: 'ExchangeOutline',
    path: PATHS.lp.exchange,
  },
  {
    title: 'Seguros',
    thumb: '',
    icon: 'ShieldOutline',
    path: PATHS.lp.lifeInsurance,
  },
  // {
  //   title: 'Sucessório',
  //   thumb: "",
  //   icon: 'SupervisorAccount',
  //   path: PATHS.lp.,
  // },
  {
    title: 'Aquisição de bens',
    thumb: '',
    icon: 'KeyOutline',
    path: PATHS.lp.goodsAcquisiton,
  },
  {
    title: 'Empresarial',
    thumb: '',
    icon: 'Building',
    path: PATHS.lp.business,
  },
];
